// import * as go from "gojs/release/go-debug-module";
const go = require("gojs");

go.Diagram.licenseKey = "28f846e2b66258c511d35a25403d7efb0bab2d3bce814df4595717f6e80b7a042590b87851d7d89382ad4dff1b75c8d9d9c46028924b0139e764d4da40ead5aeb66027b3170c408bad042e909ca87af5f87863e2c4e027a4da2adcf3f9b8c09d5febecd657c907";

import { getStartTemplate, getEndTemplate, getCommentTemplate, dropOntoLink, getDiagramLayout, getTaskTemplate } from './nodeTemplates'
import Palette from './palette'

const $ = go.GraphObject.make;

export default class FlowChart {
  constructor() {
  }

  init(diagramDivId, paletteDivId, frequentlyUsedPaletteDivId, overviewDivId, layoutType, showContextHandler, hideContextHander, contextAction, taskTypes, hasEditPerms, preventHighlight = false ) {
    this.showContextHandler = showContextHandler;
    this.hideContextHander = hideContextHander;

    this.processDiagram = $(go.Diagram, diagramDivId, getDiagramLayout(layoutType));
    this.defineNodeTemplates(showContextHandler, hideContextHander, contextAction, preventHighlight);
    this.defineLinkTemplate()

    if (paletteDivId) {
      this.palette = new Palette(paletteDivId, taskTypes)
      this.palette.init();
    }

    if (frequentlyUsedPaletteDivId) {
      this.frequentlyUsedPalette = new Palette(frequentlyUsedPaletteDivId, taskTypes)
      this.frequentlyUsedPalette.init();
    }
    
    if (overviewDivId) {
      // Overview
      $(go.Overview, overviewDivId,  // the HTML DIV element for the Overview
        { observed: this.processDiagram, contentAlignment: go.Spot.Center });   // tell it which Diagram to show and pan
    }
    // provide a context menu for the background of the Diagram, when not over any Part
    this.processDiagram.contextMenu =
    $("ContextMenu",
      this.makeButton("Paste",
        (e, obj) => e.diagram.commandHandler.pasteSelection(e.diagram.toolManager.contextMenuTool.mouseDownPoint),
        o => o.diagram.commandHandler.canPasteSelection(o.diagram.toolManager.contextMenuTool.mouseDownPoint)),
    );

    this.processDiagram.addDiagramListener("Modified", (e) => {
      window.portalEventBus.$emit("integrify-portal:processFlowModified");
    });

    this.processDiagram.addDiagramListener("ClipboardChanged", (e, obj) => {
      e.subject.each(subj => {
        // when copying a node, gojs by default uses the
        // original node data's key for the copied node data + a number
        // we don't want that
        // if copying a node with no config, give it a negative number key so that it gets treated like a new node
        // else if copying a node with config, provide the processTaskCopyFromSid and copy
        // the process task as part of the the saveProcessDiagram endpoint
        
        subj.data.name = 'Copy of ' + subj.data.name
        if (e.diagram.processTaskCopyFromNode){
          subj.data.key = 'processTaskCopyFromSid:' + e.diagram.processTaskCopyFromNode.key // e.diagram.processTaskCopy.SID
          
          subj.data.taskConfig = e.diagram.processTaskCopyFromNode.taskConfig;
          subj.data.taskRecipients = e.diagram.processTaskCopyFromNode.taskRecipients;
          subj.data.hasConfigAndRecips = e.diagram.processTaskCopyFromNode.hasConfigAndRecips;

          delete e.diagram.processTaskCopyFromNode
        } else {
          subj.data.key = -1

          subj.data.taskConfig = false;
          subj.data.taskRecipients = false;
          subj.data.hasConfigAndRecips = false;
        }
      });
    });
    this.processDiagram.addDiagramListener("LinkDrawn", (e) => {
      e.subject.data.new = true
    });

    this.processDiagram.addDiagramListener("ViewportBoundsChanged", (e) => {
      this.processDiagram.initialPosition = this.processDiagram.position
    })

    // dragged nodes are translucent so that the user can see highlighting of links and nodes
    this.processDiagram.findLayer("Tool").opacity = 0.5;

    this.processDiagram.commandHandler.doKeyDown = () => {
      var e = this.processDiagram.lastInput;
      var cmd = this.processDiagram.commandHandler;

       //console.log('e.key: ', e.key)
      
      if (e.key === "C" || e.key === "V") {  // could also check for e.control or e.shift
        // if the user is copying or pasting, don't let the diagram handle the key event
        // user should use menu commands to copy and paste
      } else if (e.key === "Del" || e.key === "Backspace") {
        if(!hasEditPerms) return
        const node = this.processDiagram.findNodeForKey(this.processDiagram.selection.toArray()[0].key)
        if (node) window.portalEventBus.$emit("integrify-portal:ProcessFlow.showPTaskDeleteDialog"); 
        else go.CommandHandler.prototype.doKeyDown.call(cmd);
      } else {
        // call base method with no arguments
        go.CommandHandler.prototype.doKeyDown.call(cmd);
      }
    };

    // auto scroll the diagram when clicking and dragging link or task
    this.processDiagram.autoScrollRegion = new go.Margin(80, 80, 80, 80)
    this.processDiagram.autoSrollInterval = 0

    // dont hide the context menu when hovering over it
    if (contextAction === 'hover') {
      this.processDiagram.toolManager.toolTipDuration = Infinity;
    }

    return this.processDiagram
  }

  defineLinkTemplate() {
    // replace the default Link template in the linkTemplateMap
    this.processDiagram.linkTemplate =
      $(go.Link,  // the whole link panel
        {
          routing: go.Link.AvoidsNodes,
          curve: go.Link.JumpOver,
          corner: 5, toShortLength: 4,
          relinkableFrom: true,
          relinkableTo: true,
          reshapable: true,
          resegmentable: true,
          // mouse-overs subtly highlight links:
          mouseEnter: function(e, link) {
            link.findObject("HIGHLIGHT").stroke = "rgba(30,144,255,0.2)";
          },
          mouseLeave: function(e, link) {
            link.findObject("HIGHLIGHT").stroke = "transparent";
          },
          mouseDragEnter: (e, link) => link.isHighlighted = true,
          mouseDragLeave: (e, link) => link.isHighlighted = false,
          // if a node from the Palette is dropped on a link, the link is replaced by links to and from the new node
          mouseDrop: dropOntoLink,
          selectionAdorned: false
        },
        new go.Binding("points").makeTwoWay(),
        $(go.Shape,  // the highlight shape, normally transparent
          { isPanelMain: true, strokeWidth: 8, stroke: "transparent", name: "HIGHLIGHT" }),

          
        // new go.Binding("stroke", "isHiglighted", function(h, obj) { 
        //     debugger;
        //   const diagram = h.diagram;
        //   if (h.isHighlighted) {
            
        //     if (h.isLookAhead && diagram.trail == "lookAhead") return "#b0fa8e";
        //     if (h.isHindSight && diagram.trail == "hindSight") return "#FBFD9B";
        //   }
        //   else {
        //         return "transparent"
        //   }
          
          
        //  }).ofObject(),
        $(go.Shape,  // the link path shape
          { isPanelMain: true, stroke: "gray", strokeWidth: 2 },
          new go.Binding("stroke", "isSelected", function(sel) { return sel ? "dodgerblue" : "gray"; }).ofObject()),
        
        $(
          go.Shape,
          { isPanelMain: true, stroke: "transparent", strokeWidth: 3 },
          new go.Binding("stroke", "isHighlighted", (h) =>
            h ? "dodgerblue" : "transparent"
          ).ofObject()
        ),
        // $(go.Shape, { isPanelMain: true, stroke: "black", strokeWidth: 1.5 }),
        
        $(go.Shape,  // the arrowhead
          { toArrow: "standard", strokeWidth: 0, fill: "gray" }),
        $(go.Panel, "Auto",  // the link label, normally not visible
          { visible: false, name: "LABEL", segmentIndex: 2, segmentFraction: 0.5 },
          new go.Binding("visible", "visible").makeTwoWay(),
        $(go.Shape, "RoundedRectangle",  // the label shape
            { fill: "#F8F8F8", strokeWidth: 0 }),
        $(go.TextBlock, "Yes",  // the label
            {
              textAlign: "center",
              font: "10pt Roboto, sans-serif",
              stroke: "#333333",
              editable: true
            },
            new go.Binding("text").makeTwoWay())
        )
      );
  }

  load(modelJson) {
    // temporary links used by LinkingTool and RelinkingTool are also orthogonal:
    this.processDiagram.toolManager.linkingTool.temporaryLink.routing = go.Link.Orthogonal;
    this.processDiagram.toolManager.relinkingTool.temporaryLink.routing = go.Link.Orthogonal;
    this.processDiagram.toolManager.hoverDelay = 200
    this.processDiagram.toolManager.linkingTool.direction = go.LinkingTool.ForwardsOnly;
    this.processDiagram.toolManager.linkingTool.linkValidation = (fromnode, fromport, tonode, toport) =>{
      // // start node should only have one outgoing link
      // if (fromnode.data.category === "Start" && fromnode.linksConnected.count > 0) 
      //   return false
      
      // deny if fromnode already links to tonode:
      const numLinksAlreadyConnectedToToNode = fromnode.linksConnected.filter(link => {
        // console.log('link.data.to',  link.data.to)
        // console.log('tonode.data.key',  tonode.data.key)
        if (link && link.data)
          return link.data.to === tonode.data.key
      })

      return numLinksAlreadyConnectedToToNode.count < 1;
    }
    

    this.processDiagram.model = go.Model.fromJson(modelJson)
    const diagramHasEndTask = this.processDiagram.model.nodeDataArray.some(node => node.category === "End")

    if (this.palette)
      this.palette.load(modelJson.theme, diagramHasEndTask)

    if (this.frequentlyUsedPalette)
      this.frequentlyUsedPalette.load(modelJson.theme, diagramHasEndTask)
  }

  defineNodeTemplates(showContextHandler, hideContextHander, contextAction, preventHighlight) {
    // This is the actual HTML context menu:
    this.cxElement = document.getElementById("contextMenu");
    const me = this

    const outerShowContextMenuCallback = (obj, diagram, tool) => {
      showContextHandler(obj, diagram, tool)
      // Optional: Use a `window` click listener with event capture to
      //           remove the context menu if the user clicks elsewhere on the page  
      if(preventHighlight)  {
        setTimeout(() => window.addEventListener("click", function () {
          me.hideCX(me, obj, preventHighlight)

        }, {
          capture: true,
          once: true
        }), 100)
        return
      }

      window.addEventListener("click", () => {this.hideCX(me)}, true);
    }

    const outerHideContextMenuCallback = () => {
      // this.hideContextMenu()
      hideContextHander()
      if (preventHighlight) {
        window.removeEventListener("click", function () {
          me.hideCX(me, obj)

        }, {
          capture: true,
          once: true
        })
        return
      }
      window.removeEventListener("click", this.hideCX, true);
    }

    // an HTMLInfo object is needed to invoke the code to set up the HTML cxElement
    var myContextMenu = $(go.HTMLInfo, {
      show: outerShowContextMenuCallback, //showContextHandler,
      hide: outerHideContextMenuCallback,
    });

    this.processDiagram.nodeTemplateMap.add("", getTaskTemplate(myContextMenu, contextAction, preventHighlight));
    this.processDiagram.nodeTemplateMap.add("Start", getStartTemplate(myContextMenu, contextAction));
    this.processDiagram.nodeTemplateMap.add("End", getEndTemplate(myContextMenu, contextAction));
    this.processDiagram.nodeTemplateMap.add("Comment", getCommentTemplate(myContextMenu, contextAction));

    // this DiagramEvent is raised when the user has drag-and-dropped something
    // from another Diagram (a Palette in this case) into this Diagram
    this.processDiagram.addDiagramListener("ExternalObjectsDropped", (e) => {
      // stop any ongoing text editing
      if (me.processDiagram.currentTool instanceof go.TextEditingTool) {
        me.processDiagram.currentTool.acceptText(go.TextEditingTool.LostFocus);
      }

      let node = me.processDiagram.findNodeForKey(me.processDiagram.selection.toArray()[0].key)

      if (this.palette && node.data.category == 'End'){
        this.palette.removeEndTask()
      }

      // handle new node from palette dropped onto existing node
      if (e.diagram.droppedOnNode){
        const targetNode = node

        if (targetNode.data.category !== "Comment") {
          const sourceNode = e.diagram.droppedOnNode
          e.diagram.startTransaction();

          // push the target node down 
          const sourceNodeCoordinates = sourceNode.data.loc.split(' ')
          const sourceNodeX = parseInt(sourceNodeCoordinates[0])
          const sourceNodeY = parseInt(sourceNodeCoordinates[1]) 
          e.diagram.model.setDataProperty(targetNode.data, 'loc', `${sourceNodeX} ${sourceNodeY + 150}`)

          // link source to target
          if (sourceNode.category == 'End')
            e.diagram.model.addLinkData({ from: targetNode.data.key, to: sourceNode.data.key })
          else
            e.diagram.model.addLinkData({ from: sourceNode.data.key, to: targetNode.data.key })

          e.diagram.commitTransaction("updateDiagramModel");
        }
        e.diagram.droppedOnNode = null
      } 
      // wait until diagram is saved before putting into edit mode
      window.portalEventBus.$on("integrify-portal:nodeDroppedOnCanvas", () => {
        if (node) {
          me.processDiagram.commandHandler.editTextBlock(node.findObject("TEXTBLOCK"))

          if (node.qb.tasktypesid === '00d7a8be-94e0-4795-911c-a86b118e0bb4') {
            node.qb.isMilestoneInitialName = true
          }
        }
      });

      window.portalEventBus.$on("integrify-portal:afterNodeTextEdit", () => {
        if (node && node.qb.tasktypesid === '00d7a8be-94e0-4795-911c-a86b118e0bb4') {
          delete node.qb.isMilestoneInitialName
        }
      })
    });
  }

  getModelJson() {
    const result = this.processDiagram.model.toJson();
    this.processDiagram.isModified = false;
    return result;
  }

  hideCX(me, obj, preventHighlight = false) {
    if (me.processDiagram.currentTool instanceof go.ContextMenuTool) {
      me.processDiagram.currentTool.doCancel();
    } else if (preventHighlight) obj.contextMenu.hide();
  }

  // To simplify this code we define a function for creating a context menu button:
  makeButton(text, action, visiblePredicate) {
    return $("ContextMenuButton",
      $(go.TextBlock, text),
      { click: action },
      // don't bother with binding GraphObject.visible if there's no predicate
      visiblePredicate ? new go.Binding("visible", "", (o, e) => o.diagram ? visiblePredicate(o, e) : false).ofObject() : {});
  }

  // print the diagram by opening a new window holding SVG images of the diagram contents for each page
  printDiagram(height, width) {

    var svgWindow = window.open();
    if (!svgWindow) return;  // failure to open a new Window
    var printSize = new go.Size(width, height);

    // var bnds = this.processDiagram.documentBounds;
    // var x = bnds.x;
    // var y = bnds.y;
    // while (y < bnds.bottom) {
    //   while (x < bnds.right) {
    //     var svg = this.processDiagram.makeSvg({ scale: 1.0, position: new go.Point(x, y), size: printSize });
    //     svgWindow.document.body.appendChild(svg);
    //     x += printSize.width;
    //   }
    //   x = bnds.x;
    //   y += printSize.height;
    // }

    var svg = this.processDiagram.makeSvg({
      size: printSize
    });
    svgWindow.document.body.appendChild(svg)

    setTimeout(function() { svgWindow.print(); }, 300);
  }

  setLayout(layoutType) {
    const diagramLayout = getDiagramLayout(layoutType)
    this.processDiagram.layout = diagramLayout.layout;
  }

  setCommentsVisibility(visible = true) {
    this.processDiagram.startTransaction("set comments visibility");
    this.processDiagram.nodes.each(node => {
      if (node.data.category === "Comment") {
        node.visible = visible;
      }
    })
    this.processDiagram.commitTransaction("set comments visibility");
  }

  setGrid(enabled, size) {
    this.processDiagram.toolManager.draggingTool.isGridSnapEnabled = enabled;
    this.processDiagram.toolManager.resizingTool.isGridSnapEnabled = enabled;

    if (enabled) {
      const gridCellWidth = 86 / size

      this.processDiagram.grid =
        $(go.Panel, "Grid",
          {
            name: "GRID",
            visible: true,
            gridCellSize: new go.Size(gridCellWidth, gridCellWidth),
            gridOrigin: new go.Point(0, 0)
          },
          $(go.Shape, "LineH", { stroke: "lightgray", strokeWidth: 0.25, interval: 1 }),
          $(go.Shape, "LineH", { stroke: "gray", strokeWidth: 0.25, interval: size }),
          $(go.Shape, "LineH", { stroke: "gray", strokeWidth: 0.25, interval: (size * 2) }), 
          $(go.Shape, "LineV", { stroke: "lightgray", strokeWidth: 0.5, interval: 1 }),
          $(go.Shape, "LineV", { stroke: "gray", strokeWidth: 0.25, interval: size }),
          $(go.Shape, "LineV", { stroke: "gray", strokeWidth: 0.25, interval: (size * 2) }) 
        );

        // simulate node movement so that existing nodes automatically snap to the grid
        this.processDiagram.moveParts(this.processDiagram.nodes, new go.Point(0, 0), false);
    } else {
      this.processDiagram.grid.visible = false;
    }
  }

  setPaletteEnabled(val) {
    this.palette.palette.isEnabled = val
    this.frequentlyUsedPalette.palette.isEnabled = val
  }

  setPaletteViewOnly() {
    this.palette.palette.isReadOnly = true //isReadOnly allows scroll where isEnabled doesn't
    this.frequentlyUsedPalette.palette.isEnabled = false    

    this.palette.palette.toolManager.draggingTool.isEnabled = false
  }
}
